package ui.dashboard

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import io.Repository
import kotlinx.coroutines.launch
import ssoft.frontend.generated.resources.Res
import ssoft.frontend.generated.resources.err_connection_interrupted
import tk.mallumo.compose.navigation.viewmodel.NavigationViewModel
import tk.mallumo.compose.navigation.viewmodel.VM
import tk.mallumo.utils.DataState
import tk.mallumo.utils.mutableDataState
import tools.await

@VM
class DashboardVM : NavigationViewModel() {

    private lateinit var scopeUi: DashboardScope


    var state by mutableDataState<DashboardScope.Wrapper>()
        private set


    sealed interface Action {

        companion object {

            @Composable
            fun rememberAction(vm: DashboardVM): (Action) -> Unit {
                return remember {
                    { act ->
//                        when (act) {
//
//                        }
                    }
                }
            }
        }
    }


    fun init(scopeUi: DashboardScope) {
        this.scopeUi = scopeUi
        if (state !is DataState.Result) {
            state = DataState.Loading()
        }


        scope.launch {
            runCatching {
                val data = if (scopeUi.args.companyId > 0) {
                    Repository.api.dashboard.byCompany(scopeUi.args.serverId, scopeUi.args.companyId)
                } else {
                    Repository.api.dashboard.byServer(scopeUi.args.serverId)
                }
                state = DataState.Result(
                    DashboardScope.Wrapper(
                        data = data,
                        charts = DashboardScope.Wrapper.make(
                            user = scopeUi.login,
                            data = data,
                            modeCompany = scopeUi.args.companyId > 0
                        )
                    )
                )
            }.onFailure {
                it.printStackTrace()
                state = DataState.Error(Res.string.err_connection_interrupted.await())
            }
        }
    }

    override fun onRelease() {
        state = DataState.Idle()
    }

}
